import React, {useEffect, useRef} from "react"
import styled from "styled-components"

import {H2, Body} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import tracking from "@irati-tracking/recognition/recognition"

import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Spacing from "@irati/ui/src/Spacing"
import theme from "@irati/ui/src/global/theme"
import recogniseSuccess from "../../../images/recognise-success.gif"

const Image = styled.img`
  height: 140px;
  margin-bottom: 16px;
  width: 140px;
`
interface Props extends InjectIntlProps {
  onClickButton: () => void
  onHide: () => void
  onViewFeed: () => void
  timeoutMilliseconds?: number
  isFirstRecognition?: boolean
}
const RecognitionSuccess: React.FC<Props> = (props) => {
  const {formatMessage, onClickButton, onHide, timeoutMilliseconds = 30000, onViewFeed, isFirstRecognition} = props
  const closeSuccessTimeout = useRef(-1)
  useEffect(() => {
    tracking.recognitionConfirmation({type: "standard", source: "recognition"})
    closeSuccessTimeout.current = setTimeout(onHide, timeoutMilliseconds)
    return () => {
      clearTimeout(closeSuccessTimeout.current)
    }
  }, [])
  const msg = isFirstRecognition
    ? "recognition.popup.createRecognition.successFirstRecognition.body"
    : "recognition.popup.createRecognition.success.body"
  const header = isFirstRecognition
    ? "recognition.popup.createRecognition.successFirstRecognition.header"
    : "recognition.popup.createRecognition.success.header"
  return (
    <div className="text-center">
      <Image alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})} src={recogniseSuccess} />
      <H2>
        <FormattedMessage id={header} />
      </H2>
      <Spacing marginBottom={theme.spacing.two} marginTop={theme.spacing.two}>
        <Body large maxWidth="100%" marginBottom={1} textAlign="center">
          <FormattedMessage id={msg} />
        </Body>
      </Spacing>
      <Button primary large full onClick={onClickButton} marginTop={4}>
        <FormattedMessage id="recognition.popup.createRecognition.success.createAgainButton" />
      </Button>
      <Button large full onClick={onViewFeed} marginTop={2}>
        <FormattedMessage id="recognition.popup.createRecognition.success.viewFeedButton" />
      </Button>
    </div>
  )
}
export default injectIntl(RecognitionSuccess)
